import React, { useEffect, useState } from "react";

function BlurImage({ lowSrc, highSrc, alt, style = {} }) {
  const [isHighResLoaded, setIsHighResLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = highSrc;
    img.onload = () => {
      setIsHighResLoaded(true);
    };
  }, [highSrc]);

  return (
    <div style={style}>
      {/* Low-Quality Image */}
      {!isHighResLoaded && (
        <img
          src={lowSrc}
          alt={alt}
          className={`project-image ${!isHighResLoaded ? "active" : ""}`}
        />
      )}

      {/* High-Quality Image */}
      {isHighResLoaded && (
        <img
          src={highSrc}
          alt={alt}
          className={`project-image ${isHighResLoaded ? "active" : ""}`}
        />
      )}
    </div>
  );
}

export { BlurImage };
